import { ScrollToMode, scroll as scrollTo } from 'owa-load-more-scroll-list';
import {
    scrollToUpNext,
    restoreSavedScrollPosition,
    scrollToTop,
    scrollToDateHeader,
    updateShouldAutoScroll,
} from '../actions/internalActions';
import {
    getUpNextIndex,
    getDateHeaderIndex,
    getAgendaListItems,
} from '../selectors/agendaEventsListViewSelectors';
import { orchestrator } from 'satcheljs';
import { getTopOfListIndex } from '../selectors/agendaStoreSelectors';
import { getScenarioActions } from '../actions/getScenarioActions';

const LOAD_MORE_BUFFER = 20;

// NOTE: This used to be 300ms but ~10-20% of the time the scroll would still miss the target by about one day.
//       Bumping to 400ms seems to provide much more reliability with minimal impact to user-perceived latency.
const SCROLL_DELAY_MS = 400;

/** requestAnimationFrame/ setTimeOut is used to ensure that when this is called the list with the updated items is mounted and rendered */
orchestrator(scrollToUpNext, actionMessage => {
    const { scenarioId } = actionMessage;
    const upNextIndex = getUpNextIndex(scenarioId);
    if (upNextIndex >= 0) {
        // delayed setTimeout is used in this case to ensure that the list is rendered,
        // because in order for the scrollTo to be accurate, it must have rendered items to measure.
        setTimeout(
            () =>
                requestAnimationFrame(() => scrollTo(scenarioId, upNextIndex, ScrollToMode.center)),
            SCROLL_DELAY_MS
        );
    } else {
        requestAnimationFrame(() => scrollTo(scenarioId, 0, ScrollToMode.top));
    }
});

/** requestAnimationFrame/ setTimeOut is used to ensure that when this is called the list with the updated items is mounted and rendered */
orchestrator(scrollToDateHeader, actionMessage => {
    const { date, scenarioId } = actionMessage;
    const dateHeaderIndex = getDateHeaderIndex(date, scenarioId);
    if (dateHeaderIndex >= 0) {
        // delayed setTimeout is used in this case to ensure that the list is rendered,
        // because in order for the scrollTo to be accurate, it must have rendered items to measure.
        if (getAgendaListItems(scenarioId, date).length - dateHeaderIndex < LOAD_MORE_BUFFER) {
            // if we're scrolling to a date header very near the border of loaded items, load more before trying to scroll
            // to try to make the header scroll to the top
            getScenarioActions(scenarioId).onLoadMoreItems();
            setTimeout(() => {
                requestAnimationFrame(() =>
                    scrollTo(scenarioId, dateHeaderIndex, ScrollToMode.top)
                );
            }, SCROLL_DELAY_MS);
        } else {
            requestAnimationFrame(() => scrollTo(scenarioId, dateHeaderIndex, ScrollToMode.top));
        }
    } else {
        requestAnimationFrame(() => scrollTo(scenarioId, 0, ScrollToMode.top));
    }

    updateShouldAutoScroll(false, scenarioId);
});

orchestrator(scrollToTop, actionMessage => {
    const { scenarioId } = actionMessage;
    const top = getTopOfListIndex(scenarioId);
    if (top !== 0) {
        requestAnimationFrame(() => scrollTo(scenarioId, 0, ScrollToMode.top));
    }
});

orchestrator(restoreSavedScrollPosition, actionMessage => {
    const { scenarioId } = actionMessage;
    const top = getTopOfListIndex(scenarioId);
    if (top) {
        // re-scroll to the saved top of list when the component mounts
        // TODO VSO: 47573 scroll on remount bug in time panel
        requestAnimationFrame(() => scrollTo(scenarioId, top, ScrollToMode.top));
    }
});
